// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchOrderForm_form__uRq0F","button":"SearchOrderForm_button__TNHIS"};